import React from "react";
import DOMPurify from "dompurify";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import CompaniesDecor from "../../img/decor/award-icon.png";

function  Companies() {
    const companiesList = [
        "Kernel",
        "ДТЕК",
        "Київстар",
        "OLX Робота",
        "Група Нафтогаз",
        "ПриватБанк",
        "Метінвест",
        "Аврора",
        "Uklon",
        "ПУМБ",
        "EVA",
        "МакДональдз",
        "NOVUS ",
        "Puma",
        "Епіцентр К",
        "Нова Пошта ",
        "Watsons ",
        "Ribas Hotels Group",
        "Укрзалізниця",
        "JYSK",
        "Meest",
        "EVAWT BavariaA",
        "BROCARD",
        "МХП",
        "L’ORÉAL",
        "ОККО",
    ];
    const row = [...companiesList, ...companiesList];

    return (
        <section className="mb-[60px] overflow-hidden lg:mb-[120px]">

            <div className="container mx-auto max-w-screen-xl px-5">
                <h2 className="mb-10 text-center text-[30px] font-bold uppercase">
                    Компанії, які відвідали захід
                </h2>
            </div>

            <div className="flex flex-col gap-5 overflow-hidden">

                {/* Ряд 1 */}
                <div className="overflow-hidden">
                    <div className="flex w-max gap-5 lg:gap-8  whitespace-nowrap hover:[animation-play-state:paused] [animation:marquee-left_155s_linear_infinite]">
                        {row.map((item, index) => (
                            <div
                                key={index}
                                className="flex shrink-0 items-center gap-5 lg:gap-8"
                            >
                                <span className="text-[28px] md:text-[40px] lg:text-[80px] leading-none font-black uppercase tracking-[-0.03em]">
                                    {item}
                                </span>

                                <img src={CompaniesDecor} alt="" aria-hidden="true" className="h-4 w-4 lg:h-8 lg:w-8"/>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Ряд 2 */}
                <div className="overflow-hidden">
                    <div className="flex w-max gap-5 lg:gap-8 whitespace-nowrap hover:[animation-play-state:paused] [animation:marquee-right_165s_linear_infinite]">
                        {row.map((item, index) => (
                            <div
                                key={index}
                                className="flex shrink-0 items-center gap-5 lg:gap-8"
                            >
                                <span className="text-[28px] md:text-[40px] lg:text-[80px] leading-none font-black uppercase tracking-[-0.03em]">
                                    {item}
                                </span>

                                <img src={CompaniesDecor} alt="" aria-hidden="true" className="h-4 w-4 lg:h-8 lg:w-8"/>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Ряд 3 */}
                <div className="overflow-hidden">
                    <div className="flex w-max gap-5 lg:gap-8 whitespace-nowrap hover:[animation-play-state:paused] [animation:marquee-left_155s_linear_infinite]">
                        {row.map((item, index) => (
                            <div
                                key={index}
                                className="flex shrink-0 items-center gap-5 lg:gap-8"
                            >
                                <span className="text-[28px] md:text-[40px] lg:text-[80px] leading-none font-black uppercase tracking-[-0.03em]">
                                    {item}
                                </span>

                                <img src={CompaniesDecor} alt="" aria-hidden="true" className="h-4 w-4 lg:h-8 lg:w-8"/>
                            </div>
                        ))}
                    </div>
                </div>

            </div>

        </section>
    )
}

export default Companies;